/**
 * What this device reports with each sync push, for the admin console's sync
 * health table: the platform (installed app or browser tab, and the OS) and
 * the build's version. Nothing identifying; never used for any decision.
 */
import { version } from '../../package.json';

export const APP_VERSION: string = version;

type NavigatorWithHints = Navigator & { userAgentData?: { platform?: string; mobile?: boolean } };

function operatingSystem(nav: NavigatorWithHints): string {
  const hinted = nav.userAgentData?.platform;
  if (hinted) return hinted;
  const ua = nav.userAgent;
  if (/android/i.test(ua)) return 'Android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
  if (/mac os x/i.test(ua)) return 'macOS';
  if (/windows/i.test(ua)) return 'Windows';
  if (/linux/i.test(ua)) return 'Linux';
  return 'unknown';
}

function installed(): boolean {
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true
    );
  } catch {
    return false;
  }
}

let cached: { platform: string; app_version: string } | null = null;

export function deviceInfo(): { platform: string; app_version: string } {
  cached ??= {
    platform: `${installed() ? 'pwa' : 'web'}/${operatingSystem(navigator as NavigatorWithHints)}`,
    app_version: APP_VERSION,
  };
  return cached;
}
